import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-filter\"><path stroke=\"currentColor\" fill=\"transparent\" d=\"M8.56 19.144v-5.256c-3.08-3.995-4.825-6.299-5.237-6.91C2.707 6.06 2.86 5 4.783 5H17.75c.957 0 1.745.873.873 1.978-.582.736-2.367 2.95-5.357 6.642V21\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol